import {
  BUDGET_ALL,
  BUDGET_GET,
  BUDGET_DEL,
  BUDGET_PUT,
  BUDGET_POST,
  BUDGET_LOADING,
  BUDGET_ERROR,
  BUDGET_RESET,
} from '../../actions/types';

const initialState = {
  budget: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case BUDGET_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case BUDGET_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case BUDGET_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case BUDGET_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case BUDGET_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    case BUDGET_RESET:
      return { budget: null, isLoading: true, isCompleted: true };
    case BUDGET_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case BUDGET_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
